import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ComparisonCard } from '../../constants/patient-curves.constants';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  selector: 'aux-ag-patient-driver-comparison-card',
  styles: [],
  templateUrl: './ag-patient-driver-comparison-card.component.html',
})
export class AgPatientDriverComparisonCardComponent {
  @Input() card: ComparisonCard | undefined;
}
